import { Box, Stack, Typography } from '@mui/material';
import useTemplateSx from '../../hooks/useTemplateSx';

export default function FormSection({ icon, title, description, children }) {
  const styles = useTemplateSx();

  return (
    <Box sx={styles.formSectionCard}>
      {(title || description || icon) ? (
        <Stack direction="row" spacing={1.25} alignItems="flex-start" sx={{ mb: 1.5 }}>
          {icon ? <Box sx={{ mt: 0.25, color: 'primary.main' }}>{icon}</Box> : null}
          <Box>
            {title ? <Typography sx={styles.formSectionTitle}>{title}</Typography> : null}
            {description ? (
              <Typography sx={styles.formSectionDescription}>{description}</Typography>
            ) : null}
          </Box>
        </Stack>
      ) : null}
      {children}
    </Box>
  );
}
